import walletPagePerformanceSectionMessages from '../../../messages/wallet/wallet-page-performance-section.messages';
import { Column } from '../../column';
import { ProductPerformance } from '../product-performance/product-performance';

export const productPerformanceColumns: Column<ProductPerformance>[] = [
  {
    headerLabel: walletPagePerformanceSectionMessages.productDescriptionColumn,
    key: 'description',
    type: 'string',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.productTypeColumn,
    key: 'type',
    type: 'string',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.contractColumn,
    key: 'contract',
    type: 'string',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.investedColumn,
    key: 'investment',
    type: 'number',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.switchInColumn,
    key: 'switchIn',
    type: 'number',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.retrievedAndDividendsColumn,
    key: 'withdrawalAndDividends',
    type: 'number',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.switchOutColumn,
    key: 'switchOut',
    type: 'number',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.averageStockColumn,
    key: 'averageDeposits',
    type: 'number',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.amountColumn,
    key: 'amount',
    type: 'number',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.plusMinusColumn,
    key: 'plusMinus',
    type: 'number',
  },
  {
    headerLabel: walletPagePerformanceSectionMessages.yieldColumn,
    key: 'gain',
    type: 'percentage',
  },

];
